<script setup lang="ts">
const props = defineProps<{
    data?: any;
}>();

const list = computed(() => {
    if (props?.data) {
        if (typeof props.data === 'string') {
            return JSON.parse(props.data)?.imAiMsgVos || [];
        } else {
            props.data?.imAiMsgVos || [];
        }
    } else {
        return [];
    }
});
</script>

<template>
    <div>
        <div
            v-for="(item, index) in list"
            :key="index"
        >
            <div
                v-if="item.msgType == 1"
                class="mb-10px"
            >
                {{ item.msgContent }}
            </div>
            <div
                v-if="item.msgType === 2"
                class="mb-10px"
            >
                <a-image :src="item.msgContent" />
            </div>
        </div>
    </div>
</template>
